module.exports = "https://static.wanderu.com/ui-react/_next/static/media/stars.54cc0037.svg";